const SvgRank = ({ size = '32', width = '32', height = '32' }) => (
  <svg
    width={size || width}
    height={size || height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0001 31C10.8304 31 6.625 26.7945 6.625 21.6249C6.625 16.4553 10.8304 12.2498 16.0001 12.2498C21.1699 12.2498 25.3753 16.4553 25.3753 21.6249C25.3753 26.7945 21.1699 31 16.0001 31ZM16.0001 13.4999C11.5201 13.4999 7.8751 17.1446 7.8751 21.6249C7.8751 26.1052 11.5201 29.7499 16.0001 29.7499C20.4802 29.7499 24.1252 26.1052 24.1252 21.6249C24.1252 17.1446 20.4802 13.4999 16.0001 13.4999Z"
      fill="#088AB2"
      stroke="#088AB2"
      strokeWidth="0.5"
    />
    <path
      d="M9.20599 15.2305L1.18018 1H9.49443L15.9225 12.6653L14.8276 13.2683L8.75581 2.24958H3.31991L10.2947 14.6159L9.20599 15.2305Z"
      fill="#088AB2"
      stroke="#088AB2"
      strokeWidth="0.5"
    />
    <path
      d="M8.57812 1.92647L9.67286 1.32318L15.9228 12.6652L14.8281 13.2685L8.57812 1.92647Z"
      fill="#088AB2"
      stroke="#088AB2"
      strokeWidth="0.5"
    />
    <path
      d="M22.7948 15.2304L21.7059 14.6165L28.6807 2.25019H23.2448L17.1731 13.2689L16.0781 12.6659L22.5062 1.00061H30.8205L22.7948 15.2304Z"
      fill="#088AB2"
      stroke="#088AB2"
      strokeWidth="0.5"
    />
    <path
      d="M16.0791 12.6658L22.3261 1.32208L23.421 1.92514L17.1741 13.2689L16.0791 12.6658Z"
      fill="#088AB2"
      stroke="#088AB2"
      strokeWidth="0.5"
    />
    <path
      d="M20.7714 28.075L16.085 25.6117L11.3985 28.075L12.294 22.8568L8.50195 19.1613L13.7418 18.3998L16.085 13.6523L18.4282 18.3998L23.6669 19.1613L19.876 22.8568L20.7714 28.075Z"
      fill="#088AB2"
    />
  </svg>
)

export default SvgRank
